<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules">
      <div class="form-card" style="position: relative">
        <!-- <h3>地址信息</h3> -->
        <div>
          <div class="flex-box" style=" width: 100%">
            <el-form-item label="运输方式" prop="transportTypeId" style="margin-right: 30px">
              <el-select v-model="form.transportTypeId" value-key="id" placeholder="请选择" clearable filterable style="width: 100%" @focus="$refs.endCountry.hideListPopover(); $refs.selectPlace3.hideListPopover()">
                <el-option v-for="item in transportList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="起运地" prop="polOb" style=" margin-right: 30px">
              <el-select v-model="form.polOb" value-key="id" placeholder="请选择起运地" clearable filterable :filter-method="(query) => filterMethod(query, 'pol')" @focus="startOptions = startList; $refs.endCountry.hideListPopover(); $refs.selectPlace3.hideListPopover()" style="width: 100%">
                <el-option class="shelf_set" :label="item.type === 1 ? item.portNamec : item.cityNamec" :value="item" v-for="(item, index) in startOptions" :key="item.id">
                  <div>
                    <div class="place-item"
                      :class="{isCurrent: form.polOb && item.id === form.polOb.id}">
                    <div class="place-item__type" slot="left">
                      <img class="place-item__type-icon" :src="ossPath + (item.type === 1 ? '/pages/home/icon_port_new.png' : '/pages/home/icon_city_type.png')">
                      <div class="place-item__type-text">{{item.type === 1 ? '港口' : '城市'}}</div>
                    </div>
                    <div class="place-item__content" slot="right">
                      <div class="place-item__text-row">{{item.portNamee ? `${item.portNamee}, ` : ''}}{{item.cityNamee ? `${item.cityNamee}, ` : ''}}{{item.countryNamee || ''}}</div>
                      <div class="place-item__text-row">{{item.portNamec ? `${item.portNamec}, ` : ''}}{{item.cityNamec ? `${item.cityNamec}, ` : ''}}{{item.countryNamec || ''}}</div>
                    </div>
                  </div>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的国" prop="podOb" :class="{isfocus: focusStatus.country}" style="margin-right: 30px; position: relative;">
              <!-- <el-select v-model="form.podCountryId" placeholder="请选择目的国" clearable filterable style="width: 100%">
                <el-option v-for="item in countryData" :key="item.id" :label="`${item.countryNamec} ${item.countryNamee}`" :value="item.id">
                  <span style="float: left">{{item.countryNamec}}</span>
                  <span style="float: right">{{item.countryNamee}}</span>
                </el-option>
              </el-select> -->
                <select-place-template4
                  :class="{isfocus: focusStatus.country}"
                  ref="endCountry"
                  v-model="form.podOb"
                  :tab-head-list="continentCountryTabHeadList"
                  :default-tab-value.sync="continentCountryDefaultTabValue"
                  :data="continentCountryDataset"
                  :is-loading="continentCountryLoading"
                  filter-hot
                  filter-other-tabs
                  @change="changeEndPlace"
                  @focus="focusAndBlur('country',true)"
                  @blur="focusAndBlur('country',false)"
                  popover-width="600"
                  placeholder="请选择目的国家"
                  class="select-place-item"
                  :clearable="false"
                />
                <i class="el-icon-arrow-down" style="position: absolute; bottom: 14px; right: 15px"></i>
            </el-form-item>
            <el-form-item label="FBA仓" prop="podWarehouse" :class="{isfocus: focusStatus.warehouse}" style="position: relative;">
              <!-- <el-select v-model="form.podOb" value-key="id" placeholder="请选择" clearable filterable style="width: 100%">
                
              </el-select> -->
              <select-place-template3
                :class="{isfocus: focusStatus.warehouse}"
                ref="selectPlace3"
                v-model="form.podWarehouse"
                :tab-head-list="[{
                  label: 'FBA仓库',
                  value: 'fba',// tab自身标识
                  listLevel:2,// 列表的层级，只支持1和2
                  showLeftLabel:true,// 2级列表是否显示左边的分组标签（展示首字母开头）
                  openSelectAll:false,// 是否展示全选按钮
                }]"
                :isVisibleTab="false"
                :selectAllButton="false"
                default-tab-value.sync="fba"
                :data="destinationListGroupData"
                @focus="focusAndBlur('warehouse',true)"
                @blur="focusAndBlur('warehouse',false)"
                :is-loading="endWarehouseLoading"
                :disabled="!form.podOb || !form.podOb.id"
                :placeholder="endWarehousePlaceholder"
                class="select-place-item"
                :multiple="false"
                select-all-button
                :clearable="false"
              >
              </select-place-template3>
              <i class="el-icon-arrow-down" style="position: absolute; bottom: 14px; right: 15px"></i>
            </el-form-item>
          </div>
          <div class="flex-box">
            <el-form-item label="货物类型" prop="goodsTypeList" style="flex-grow: 1">
              <checkGroup v-model="form.goodsTypeList" style="width: 100%" @change="$refs.form.validateField('goodsTypeList')" />
            </el-form-item>
            <div class="flex-box" style="justify-items: flex-end">
                <el-form-item label="货物信息" prop="goodsInfoKg">
                  <el-input class="short-input connect-left" style="" v-model="form.goodsInfoKg" placeholder="请输入">
                    <span slot="suffix" style="color: #141414">KG</span>
                  </el-input>
                </el-form-item>
                <el-form-item prop="goodsInfoCbm">
                  <div style="height: 30px"></div>
                  <el-input class="short-input connect-right center" style="margin-left: -2px;" v-model="form.goodsInfoCbm" placeholder="请输入">
                    <span slot="suffix" style="color: #141414">CBM</span>
                  </el-input>
                </el-form-item>
                <el-form-item prop="goodsInfoBox">
                  <div style="height: 30px"></div>
                  <el-input class="short-input connect-right" style="margin-left: -1px;" v-model="form.goodsInfoBox" placeholder="请输入">
                    <span slot="suffix" style="color: #141414">箱</span>
                  </el-input>
                </el-form-item>
              </div>
          </div>
          <div class="flex-box">
            <el-form-item label="预计出货日期" prop="sendGoodsTime" style="width: 240px; margin-right: 30px">
              <el-date-picker style="width: 100%;" v-model="form.sendGoodsTime" value-format="yyyy-MM-dd" type="date" size="normal" placeholder="请选择" prefix-icon="el-icon-date">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="商品名称" prop="goodsName" style="width: 370px; margin-right: 30px">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 1, maxRows: 10 }" style="width: 100%" v-model="form.goodsName" placeholder="请输入商品名称或HS Code，支持用/，隔开" clearable maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="需求说明" prop="needDescription" style="margin-bottom: 0; flex-grow: 1">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 1, maxRows: 10 }" style="width: 100%" v-model="form.needDescription" placeholder="请输入需求说明" clearable maxlength="200" show-word-limit></el-input>
            </el-form-item>
          </div>
          <div style="position: relative; height: 0">
            <!-- 占位用 -->
            <el-form-item label="占位" style="opacity: 0; width: 0">
              <el-input></el-input>
            </el-form-item>
          </div>
          <!-- <div class="">
          </div>
          <div>
          </div> -->
          <div align="right">
            <div class="primary-button" @click="publishCommit">发布询盘</div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import {isObject} from "my-tools-kit"
import {mapState, mapGetters} from 'vuex'
import selectPlace from './selectPlace'
import selectGoodsType from './selectGoodsType'
import checkGroup from './checkGroup.vue'
// import {sendCustomerOperationRecord} from "@/assets/js/utils"
import SelectPlaceTemplate3 from "@common/newSelectPlace/selectPlaceTemplate3"
import SelectPlaceTemplate4 from "@common/newSelectPlace/selectPlaceTemplate4"
import {getLocalId, sendCustomerOperationRecord, sendStatisticHotCountry} from "@/assets/js/utils";
import {
  disposeDestinationList
} from "@/assets/js/utils.selectPlace";
export default {
  components: {
    selectPlace,
    selectGoodsType,
    checkGroup,
    SelectPlaceTemplate3,
    SelectPlaceTemplate4
  },
  props: {
    initForm: {
      type: Object,
      default: () => {}
    },
    inquiryBusinessType: { // 询盘业务类型  1 海运整柜 、2 FBA、3 海运拼箱、4 空运、5 陆运
      type: [String,Number],
      default: 1,
    },
    inquiryType: { // 1、港到港 2、整柜到门 3、门到港 4、门到门
      type: [String,Number],
      default: 2,
    }
  },
  data() {
    const validCbm = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入体积'))
      } else if (value <= 0 || !Number(+value)) {
          callback(new Error("请输入有效正数"))
      } else {
        callback()
      }
    }
    const validBox = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入箱数'))
      } else if (value <= 0 || !Number.isInteger(+value)) {
          callback(new Error("请输入有效正整数"))
      } else {
        callback()
      }
    }
    return {
      form: {
        // findSupplierNum: 5,
        goodsTypeList: [],
        // boxTypeList: [{
        //   boxNum: 1
        // }]
      },
      rules: {
        transportTypeId: [{ required: true, message: '请选择运输方式', trigger: 'change' }],
        polOb: [{ required: true, message: '请选择起运地', trigger: 'change' }],
        // podCountryId: [{ required: true, message: '请选择目的国', trigger: 'change' }],
        podOb: [{ required: true, message: '请选择目的国', trigger: 'change' }],
        podWarehouse: [{ required: true, message: '请选择FBA仓', trigger: 'change' }],
        podAddressDetail: [{ required: true, message: '请输入派送详细地址' }, { min: 10, message: '请至少输入10个字符' }],
        goodsTypeList: [{ required: true, message: '请选择货物类型' }],
        goodsInfoKg: [{ required: true, message: '请输入重量' }, { validator: validCbm }],
        goodsInfoCbm: [{ validator: validCbm }],
        goodsInfoBox: [{ validator: validBox }],
        sendGoodsTime: [{ required: true, message: '请选择预计出货日期' }],
        // goodsName: [{ required: true, message: '请输入商品名称' }],
        // needDescription: [{ required: true, message: '请输入需求说明' }]
      },
      boxTypeOptions: [],
      successVisible: false,
      currentFoc: null,
      startList: [],
      endList: [],
      startOptions: [],
      endOptions: [],
      countryData: [],
      transportList: [],
      endWarehouseLoading:false,
      continentCountryLoading:false,
      continentCountryDataset:{},//数据集
      continentCountryTabHeadList:[],
      continentCountryDefaultTabValue:"",// 目的地选择弹窗默认选中的tab
      endWarehouseList: [],
      /* 输入样式框 获取焦点状态 */
      focusStatus:{
        country:false,
        warehouse:false
      },
    }
  },
  computed: {
    ...mapState(['Authorization']),
    ...mapGetters(["token"]),
    /**
     * 目的地选择框展示的 placeholder 文本内容
     */
    endWarehousePlaceholder() {
      return this.form.podOb && this.form.podOb.id ? '请选择目的地' : '请先选择国家'
    },
    /**
     * 目的地分组列表数据
     */
    destinationListGroupTabConfig(){
      let list =  [];
      let fba = {
        label:"FBA仓库",
        value:"fba",// tab自身标识
        listLevel:2,// 列表的层级，只支持1和2
        showLeftLabel:true,// 2级列表是否显示左边的分组标签（展示首字母开头）
        openSelectAll:false,// 是否展示全选按钮
      };
      // let fbx = {label:"FBX仓库", value:"fbx", listLevel:2, showLeftLabel:true, openSelectAll:true, };
      let privateCity = {label:"非FBA仓(城市)", value:"privateCity", listLevel:2, showLeftLabel:true, openSelectAll:false, };
      let zipCode = {label:"非FBA仓(邮编)", value:"zipCode", listLevel:1, showLeftLabel:false, openSelectAll:false, };
      let inputZipCode = {label:"非FBA仓(邮编)", value:"noFba", listLevel:1,};

      list.push(fba);
      let country = this.endPlace;
      if(country.id){
        if(country.privateAddressType === 2){
          list.push(privateCity);
        }else{
          list.push(inputZipCode);
        }
        if(String(this.defaultProductType) === "1"){
          this.destinationDefaultTabValue = "fba";
        }else{
          if(country.privateAddressType === 2){
            this.destinationDefaultTabValue = "privateCity";
          }else{
            this.destinationDefaultTabValue = "noFba";
          }
        }
      }else{
        this.destinationDefaultTabValue = "fba";
      }

      // list.push(
      //   {label:"非FBA仓", value:"noFba", listLevel:1, },
      // )
      return list;
    },
    /**
     * 目的地分组列表数据
     */
    destinationListGroupData(){
      return {
        fba:this.endWarehouseList
      }
    },
  },
  watch: {
    token: {
      immediate: true,
      handler(val) {
       if (val) this.getBoxTypeList()
      }
    }
  },
  mounted() {
    this.getDefaultList()
    this.getContinentEndCountryList()
  },
  methods: {
    /**
     * 获取 目的仓库列表
     */
    getEndWarehouseList(countryId){
      const data = {
        countryId,
      };
      const url = "/api/warehouse/getFBAAndPrivateWarehouseList";
      this.endWarehouseLoading = true;
      return this.axios.get(url, {params:data})
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          this.endWarehouseLoading = false;
          let list = res.datas||[];
          list = disposeDestinationList(list);
          this.endWarehouseList = list;
          return res;
        })
        .catch(res=>{
          this.endWarehouseLoading = false;
          this.endWarehouseList = [];
          return Promise.reject(res);
        })
    },
    /**
     * 输入样式框 改变焦点状态
     */
    focusAndBlur(key="",isFocus=false){
      if(!key) return false;
      this.focusStatus[key] = isFocus;
      // if (key === 'country' && !isFocus) this.$refs.endCountry.hideListPopover()
    },
    /**
     * 变更 目的国
     */
    changeEndPlace(data = {}){
      console.log("变更 目的国",Object.assign({},data));
      const countryId = data.id;
      if (this.form.podWarehouse) this.form.podWarehouse = null
      this.$refs.form.validateField('podOb')
      // // 目的仓库
      // // this.endWarehouse = {};
      // this.endWarehouseSelectList = [
      //   {namec:"全部",id:"all"},
      // ];
      // this.endWarehouseList = [];
      // this.privateCityList = [];
      // this.zipCodeList = [];

      // // 货物类型
      // this.goodsTypeList = [
      //   {goodsTypeName:"全部",goodsTypeId:""},
      // ];
      // this.goodsType = "";
      // // 产品名称（商品名）
      // this.goodsNameCurrent = ''
      // this.goodsNameList = []

      // this.getGoodsType(countryId);
      this.getEndWarehouseList(countryId);

      // if (this.$refs.goodsSelect) {
      //   this.$refs.goodsSelect.hideListPopover()
      //   this.$refs.goodsSelect.selectItem(null)
      // }
      // if(data.privateAddressType === 2){
      //   this.getPrivateCityList(countryId);
      // }else{
      //   this.getZipCodeList({
      //     country: data.namec||"",
      //     countryCode: data.code||"",
      //     countryId: countryId||"",
      //     privateAddressType:data.privateAddressType,
      //   })
      // }

    },
    /**
     * 根据七大洲分类获取所有国家列表
     */
    getContinentEndCountryList() {
      const data = {};
      const url = "/api/filedata/findContinentCountryList";
      this.continentCountryLoading = true;
      return this.axios.get(url, {params: data})
        .then(res => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.continentCountryLoading = false;
          let list = res.datas || [];
          let {defaultValue,tabHeadList,dataset} = this.createContinentEndCountryTabHeadList(list);
          // console.log('1==============',defaultValue,tabHeadList,dataset)
          this.continentCountryDefaultTabValue = defaultValue;
          this.continentCountryTabHeadList = tabHeadList;
          this.continentCountryDataset = dataset;
          return res
        })
        .catch(res => {
          this.continentCountryLoading = false;
          this.continentCountryDefaultTabValue = "";
          this.continentCountryTabHeadList = [];
          this.continentCountryDataset = {};
          // return Promise.reject(res);
        })
    },
    /**
     * 大洲排序并删除南极洲
     * @param list
     * @param key
     */
    continentListSort(list = [], key = 'continentName') {
      const sortedContinent = ['全部', '亚洲', '欧洲', '非洲', '北美洲', '南美洲', '大洋洲']
      list = list.filter(continentItem => continentItem[key] !== '南极洲')
      list = list.sort((a, b) => {
        const index1 = sortedContinent.findIndex(item => a[key] === item)
        const index2 = sortedContinent.findIndex(item => b[key] === item)
        return index1 - index2
      })
      return list
    },
    createContinentEndCountryTabHeadList(topList=[]){
      topList = this.continentListSort(topList, 'continentNameCn')
      let tabHeadList =  [];
      let defaultValue = "";
      let dataset = {};
      topList.forEach((item,index)=>{
        let id = `${item.continentId||""}`;
        if(!id) id = getLocalId();
        let namec = item.continentNameCn||"";
        let childList = item.countryInfoList||[];
        childList.forEach(twoItem=>{
          twoItem.continentNameCn = item.continentNameCn||"";
          twoItem.continentNameEn = item.continentNameEn||"";
          twoItem.privateAddressType = twoItem.privateAddressType || 1;
        })
        if(index === 0 ) defaultValue = id;
        let code = `${item.code||""}`;
        let opt = {
          label: namec,
          value: id,// tab自身标识
          listLevel:1,// 列表的层级，只支持1和2
          showLeftLabel:false,// 2级列表是否显示左边的分组标签（展示首字母开头）
          openSelectAll:false,// 是否展示全选按钮
        };
        if(!dataset[id]) {
          dataset[id] = childList;
          tabHeadList.push(opt);
        }
      })
      return {
        defaultValue,
        tabHeadList,
        dataset,
      }
    },
    filterMethod(query, type) {
        let filterFunction = (text="",item)=>{
        // console.log("============",item[this.itemLabelKey])
        let itemLabel = String(item.cityNamec||"");
        let itemLabelE = String(item.cityNamee||"")
        let itemLabel1 = String(item.portNamec||"");
        let itemLabelE1 = String(item.portNamee||"")
        let itemLabel2 = String(item.countryNamec||"");
        let itemLabelE2 = String(item.countryNamee||"")
        let itemLanbelCode = String(item.portCode || '')
        let reg = RegExp(text,"ig");
        return reg.test(itemLabel) || reg.test(itemLabelE) || reg.test(itemLabel1) || reg.test(itemLabelE1) || reg.test(itemLabel2) || reg.test(itemLabelE2) || reg.test(itemLanbelCode);
      };
      if (type === 'pol') {
        if (query) {
          this.startOptions = this.startList.filter(item=>{
            return filterFunction(query,item);
          })
        } else this.startOptions = this.startList
      } else {
        if (query) {
          this.endOptions = this.endList.filter(item=>{
            return filterFunction(query,item);
          })
        } else this.endOptions = this.endList
      }
    },

     /**
     * 获取海外港列表
     */
     getList(isEndPlace){
      const data = {
        type: isEndPlace ? 2 : 1,
        inquiryBusinessType: this.inquiryBusinessType
      }
      if (data.inquiryBusinessType == '1') data.inquiryType = this.inquiryType
      // if (isEndPlace) data.countryId = this.form.polOb.countryId
      return this.axios.post('/api/fullContainer/getHomeCityPortList', data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return {data:res.datas||[]};
        })
    },
    getDefaultList(){
      this.getList()
        .then(res=>{
          this.startList = res.data;
          this.startOptions = this.startList
        })
        .catch(res=>{
          this.startList = [];
          this.startOptions = this.startList
        })
        this.getList(true)
        .then(res=>{
          this.endList = res.data;
          this.endOptions = this.endList
        })
        .catch(res=>{
          this.endList = [];
          this.endOptions = this.endList
        })
        this.getCountryList()
        this.getTransport()
    },
    getCountryList() {
      this.axios.post('/fullContainer/getHomeCityPortList', { type: 3 })
        .then(res => {
          this.countryData = res.data.datas
        })
    },
    getTransport() {
      this.axios.get('/fbxData/getAllTransportTypes')
        .then(res => {
          this.transportList = res.data.datas
        })
    },
    setRule(val) {
      this.$refs.form.validateField(val)
    },
    setDisabled(id) {
      return this.form.boxTypeList.find(v => v.boxTypeId === id ) ? true : false
    },
    getBoxTypeList () {
      // busFCL/findAllCntype
      this.axios.get('/busFCL/findAllCntype')
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return
          this.boxTypeOptions = res.datas
        })
    },
    // connectBoxStr(list) {
    //   if (!list) return ''
    //   let text = ''
    //   list.forEach((el, i) => {
    //     const boxName = this.boxTypeOptions.find(v => v.id === el.boxTypeId).code
    //     if (i === 0) {
    //       text += `${boxName}*${el.boxNum}`
    //     } else {
    //       text += `, ${boxName}*${el.boxNum}`
    //     }
    //   })
    //   return text
    // },
    changeNum(val, i) {
      this.$nextTick(() => {
        if (!val) this.$set(this.form.boxTypeList[i], 'boxNum', 1)
      })
    },
    publishCommit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const data = {
          inquiryBusinessType: this.inquiryBusinessType,
          // inquiryType: this.inquiryType,
          customerId: this.Authorization.customerid,
          userId: this.Authorization.userId,
          ...this.form
        }
        data.goodsTypeList = this.form.goodsTypeList.map((v, i) => {
          const {
            goodsTypeName
          } = v
          return {
            goodsTypeName,
            goodsTypeId: v.id,
            sort: i
          }
        })
        data.polId = data.polOb.id
        data.polType = data.polOb.type
        data.podCountryId = data.podOb.id
        data.podId = data.podWarehouse.id
        data.podType = 3
        data.goodsInfoBox = Number(data.goodsInfoBox)
        delete data.polOb
        delete data.podOb
        delete data.podWarehouse
        console.log(data)
        const typeOb = {
          1: '整柜到门',
          2: 'FBA',
          3: '海运拼箱',
          4: '国际空运',
          5: '陆运'
        }
        sendCustomerOperationRecord('提交发布询盘', `类型：${typeOb[this.inquiryBusinessType]}， 起运地：${this.form.polOb.cityNamec}，目的地：${this.form.podOb.namec}${this.form.podWarehouse.namec}，货物信息：${this.form.goodsInfoKg}KG, ${this.form.goodsInfoCbm}CBM, ${this.form.goodsInfoBox}箱`)
        this.axios.post('/fullContainer/addFullContainerInquiryInfoNew', data).then(res => {
          if (res.data.code === 200) {
            // this.$message.success('成功')
            // this.successVisible = true
            this.$router.replace({
              name: 'publishedSuccess',
              query: {
                id: res.data.data.inquiryId
              }
            })
          } else {
            this.$message.error(res.data.message)
          }
        })
      })
    },
    changeFocus(val) {
      setTimeout(() => {
        this.currentFoc = val
      }, 20)
    },
    published() {
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      if (this.Authorization.authenticationInfoDTO.type != '1' || this.Authorization.authenticationInfoDTO.state != '3') return this.blockvisible = true
      this.publishCommit()
    },
  }
}
</script>

<style lang="scss" scoped>
  .query-bar {
    display: flex;
    background: #ffffff;
    .query-item {
      box-sizing: border-box;
      position: relative;
      margin-right: 10px;
      padding: 14px 20px;
      width: 480px;
      max-width: 480px;
      height: 90px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #E3E3E3;
      .select-place {
        /deep/ .search-text {
          .el-input__inner::placeholder {
            font-size: 18px;
            font-weight: bold;
            color: #999999;
          }
        }
      }
      &.isFocus {
        border: 1px solid #141414;
      }
      label {
        margin-bottom: 8px;
        display: block;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
        line-height: 22px;
      }
      /deep/ .select-place {
        line-height: 28px;
        font-size: 20px;
        font-weight: bold;
        color: #141414;
        background: transparent;
        .text-row {
          padding: inherit
        }
      }
      .right-icon {
        position: absolute;
        bottom: 22px;
        right: 20px;
        font-size: 16px;
        color: #141414;
      }
    }
    .query-button {
      width: 188px;
      height: 90px;
      line-height: 90px;
      background: #FF4D01;
      color: #FFFFFF;
      text-align: center;
      font-size: 22px;
      font-weight: 500;
      border-radius: 8px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
      img {
        margin-bottom: 3px;
        width: 21px;
        height: 21px;
        vertical-align: middle
      }
    }
  }
  
  .dropdown {
    position: absolute;
    right: 21px;
    bottom: 24px;
    transform: rotate(0);
    transition: all .3s ease;
    &.is-focus {
      transform: rotate(180deg);
    }
  }
  .form-card {
  // margin-bottom: 20px;
  // padding-top: 20px;
  background: #FFFFFF;
  border-radius: 12px;
  color: #141414;
  font-size: 16px;
  font-weight: bold;
  &>h3 {
    &::before {
      content: '';
      margin-right: 6px;
      display: inline-block;
      width: 4px;
      height: 22px;
      background: #FF4D01;
      vertical-align: text-bottom;
      border-radius: 1px;
    }
  }
  .el-form-item {
    margin-bottom: 12px;
    .el-icon-arrow-down {
      transition: all .3s;
    }
    &.isfocus .el-icon-arrow-down {
      transform: rotate(180deg);
    }
    /deep/ .el-form-item__content {
      width: 100%!important;
      margin-left: 0 !important;
    }
    /deep/ .el-textarea__inner {
      min-height: 40px!important;
      line-height: 28px !important;
      &::placeholder {
        color: #999999;
      }
    }
    /deep/ .el-textarea {
      .el-input__count {
        line-height: 30px !important;
      }
    }
    /deep/ .el-input__inner {
      &::placeholder {
        color: #999999;
      }
    }
  }
  h3,
  .contain,
  .el-form-item /deep/ .el-form-item__label {
    width: 100%!important;
    color: #999999;
    font-weight: 400;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }
  .el-form-item /deep/ .el-input__inner, /deep/ .el-textarea__inner {
    color: #141414;
    font-size: 14px;
    font-weight: bold;
    border-color: #EEEEEE;
    &:focus {
      border-color: #FF4D01
    }
  }
  /deep/ .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #F56C6C;
  }
  /deep/ .el-input-number__decrease {
    left: 2px;
    background: transparent;
  }
  /deep/ .el-input-number__increase {
    background: transparent;
  }
  /deep/ .el-form-item__error {
    font-weight: normal;
  }
  h3 {
    margin-bottom: 25px;
    font-size: 20px;
  }
  .short-input {
    width: 152px;
  }
  .el-date-editor {
    /deep/ .el-input__inner {
      padding-left: 15px;
    }
    /deep/ .el-input__prefix {
        position: absolute;
        left: 205px; // left根据实际情况定值
        top: 0;
        color:#141414;
        font-size: 20px;
        .el-input__icon {
          font-weight: bold;
        }
        
     }
     /deep/ .el-input__suffix {
      right: 30px;
     }
    //  input {
    //    padding-left: 15px;
    //  }
  }
  .select-place-template {
    width: 285px;
    height: 40px;
    line-height: 40px;
    background: transparent;
    border-radius: 4px;
    /deep/ .search-text input.el-input__inner {
      height: 38px;
      line-height: 38px;
      border: 1px solid #EEEEEE;
    }
    &.isfocus /deep/ .search-text .el-input__inner {
      border: 1px solid #FF4D01;
    }
  }
  .is-error /deep/ .search-text .el-input__inner {
    border: 1px solid #F56C6C;
  }
}
.flex-box {
  display: flex;
  // div {
  //   display: inline-block;
  // }
}

.connect-left {
  /deep/ .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    &:focus {
      position: relative;
      z-index: 1;
    }
  }
  /deep/ .el-input__suffix {
    z-index: 1;
  }
}
.connect-right {
  &.center {
    /deep/ .el-input__inner {
      border-radius: 0;
    }
  }
  /deep/ .el-input__inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    &:focus {
      position: relative;
      z-index: 1;
    }
  }
  /deep/ .el-input__suffix {
    z-index: 1;
  }
}
.shelf_set.el-select-dropdown__item {
  height: auto;
  min-height: 34px;
  padding: 0 !important;
  &:hover {
    background: transparent;
  }
}
.primary-button {
  display: inline-block;
  margin-top: 10px;
  width: 270px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #FF4D01;
  font-size: 22px;
  font-weight: bold;
  color: #FFFFFF;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    opacity: .8;
  }
}

.place-item{
  width: 100%;
  height: 50px;
  // margin: 7px 0;
  padding-right: 10px;
  //padding: 20px 20px 18px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  &:hover{
    background-color: rgba(255, 77, 1, .1);
    color: #FF4D01;
  }
  &.isCurrent {
    background-color: rgba(255, 77, 1, .1);
    color: #FF4D01;
    .place-item__text-row {
      color: #FF4D01;
    }
  }
  &__type{
    width: 64px;
    position: relative;
    z-index: 1;
    // &:before{
    //   content: "";
    //   position: absolute;
    //   top: 0;
    //   bottom: 0;
    //   right: 0;
    //   width: 1px;
    //   background-color: #D7D7D7;
    // }
    &-icon{
      //width: 19px;
      display: block;
      min-width: 1px;
      width: auto;
      height: 20px;
      margin: 0 auto;
    }
    &-text{
      text-align: center;
      height: 17px;
      line-height: 17px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
  }
  &__content{
    margin-left: 5px;
  }
  &__text-row{
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
  &:hover &__text-row{
    color: inherit;
  }
}

.el-input-number /deep/ .el-input-number__decrease {
  color: #141414;
  .el-icon-plus {
    font-weight: bold!important;;
  }
}
.el-input-number /deep/ .el-input-number__increase {
  color: #141414;
  /deep/ .el-icon-minus {
    font-weight: bold!important;;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/inquiryQueryBar/home-inquiry-fba.vue